export default __webpack_public_path__ + "static/media/star-rating-low-performer.27fe7dd1.svg";